import React from "react";
import { 
  Row,
  Col,
} from "antd";
import moment from "moment";
 export default function UserMember(props){
    return <>
    {props&&props.member
        ? props.member.map((item) => {
          return (
            <div>
              <p className='mi_address_card'>{item.Id}</p>
            <Row>
              <Col md={6} sm={24}>
                <p className="mi_name">Name</p>
                <p className="mi_value">{item.name}</p>
              </Col>
              <Col md={6} sm={24}>
                <p className="mi_name">Date of Birth</p>
                <p className="mi_value">{item.dateOfBirth?moment( item.dateOfBirth).format("MM/DD/yyyy"):"none"}</p>
              </Col>
              <Col md={6} sm={24}>
                <p className="mi_name">Relation</p>
                <p className="mi_value">{item.relation}</p>
              </Col>
              <Col md={6} sm={24}>
                <p className="mi_name">Gender</p>
                <p className="mi_value">{item.gender}</p>
              </Col>
            </Row>
          </div>
          );
        }) : ''}</>;
};